import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import ActionCreator from "../../ActionCreator";
import BaseGridItem from "../BaseGridItem";
import Image from "../ImageBackground";

class ProductGridItem extends Component {
  render() {
    let { item, onClick, navActions, promotion = false } = this.props;
    return (
      <Wrapper extraHeight={100}>
        <Image
          src={item.image}
          css="margin-bottom: 10px; height: calc(100% - 100px); background-color: #e0e0e0;"
          onClick={onClick}
        />
        {promotion && <div className="badge">活動限定</div>}
        <div className="text">
          <div
            className="store"
            onClick={() => navActions.push(`/store/?id=${item.store.id}`)}
          >
            {item.store ? item.store.name : "----"}
          </div>
          <div onClick={onClick}>
            <div className="name">{this._limitWords(item.name)}</div>
            <div className="price">
              <span className="original">
                {item.original_price && `$ ${item.original_price}`}
              </span>
              <span>$ {item.price ? item.price : "---"}</span>
            </div>
          </div>
        </div>
      </Wrapper>
    );
  }

  _limitWords = text => {
    if (text.length >= 26) {
      text = text.slice(0, 24) + "...";
    }

    return text;
  };
}

const Wrapper = styled(BaseGridItem)`
  cursor: pointer;
  background-color: #ffffff;
  text-align: center;
  font-size: 14px;
  color: #4e4e4e;
  position: relative;

  & > .badge {
    padding: 5px 10px;
    min-width: 70px;
    background: #b9a087;
    text-align: center;
    color: white;

    position: absolute;
    top: 0px;
    left: 0px;
  }

  & > .text {
    & .store {
      margin-bottom: 10px;
      font-weight: 500;

      & :hover {
        text-decoration: underline;
      }
    }

    & .name {
      line-height: 20px;
      margin-bottom: 6.5px;
    }

    & .price {
      & > .original {
        margin-right: 5px;
        text-decoration: line-through;
        color: #bfbfbf;
      }
    }
  }

  & :hover {
    opacity: 0.8;
  }
`;

export default connect(
  null,
  ActionCreator
)(ProductGridItem);
